const URLactual = window.location.href;
let result;
if(URLactual=='http://app.controlparts.cl/' || 
    URLactual=='https://app.controlparts.cl/' || 
    URLactual=='http://www.app.controlparts.cl/' ||
    URLactual=='https://www.app.controlparts.cl/'){
    result=true
} else {
    if(URLactual=='http://qa.controlparts.cl/' || 
        URLactual=='https://qa.controlparts.cl/' || 
        URLactual=='http://www.qa.controlparts.cl/' ||
        URLactual=='https://www.qa.controlparts.cl/'){
        result=true
    } else {
        result=false
    }
};
export default result